import { jsx as _jsx } from "react/jsx-runtime";
import { StyledLabel } from "./label.scss";
const Label = ({ text, borderColor })=>/*#__PURE__*/ _jsx(StyledLabel, {
        className: "generic-text",
        borderColor: borderColor,
        children: text
    });
export default Label;
